module.exports = __webpack_public_path__ + "img/button_pause.984a12c2.png";